module.exports = __webpack_public_path__ + "img/kmlookbook16web.64ff0b46.jpg";